"use client"

import { Divider } from "@heroui/divider"

export default function PageClient() {
  const handleClick = () => {
    window.open("https://snaptheprice.com/", "_blank")
  }
  return (
    <div className="flex-col items-center px-3 pt-4 text-[#1D2129] sm:px-[120px] sm:pt-10">
      <div className="mb-3 text-[24px] font-bold sm:text-[36px]">
        How to Cash Out Your SnapThePrice Rewards
      </div>
      <div className="mb-6 sm:mb-[40px]">
        SnapThePrice doesn’t just help you save money—it also rewards you while
        you shop! Once your rewards balance reaches the minimum threshold, you
        can cash out easily. Below is a step-by-step guide on how to withdraw
        your rewards or exchange them for gift cards.
      </div>
      <div className="opacity-100">
        <Divider />
      </div>
      <div className="mb-1 text-[20px] font-bold sm:mt-[32px] sm:mb-3">
        Reward Options
      </div>
      <div className="mb-1 text-[14px] sm:mb-3">
        You can choose to redeem your payable balance in two ways:
      </div>
      <div className="mb-2 text-[14px]">
        1. Amazon Gift Card – Receive an Amazon gift card equal to your payable
        balance.
      </div>
      <div className="mb-3 text-[14px] sm:mb-8">
        2. PayPal Cash – Get your payable balance transferred directly to your
        PayPal account.
      </div>
      <div className="mb-1 text-[20px] font-bold sm:mb-3">Payment Channels</div>
      <div className="mb-1 text-[14px] sm:mb-3">
        You can choose to redeem your payable balance in two ways:
      </div>
      <ul className="list-disc pl-5 text-[14px] text-[#4E5969]">
        <li className="mb-2">
          PayPal: Bind your PayPal account and set it as Primary to receive
          cash.
        </li>
        <li className="mb-2">
          Amazon Gift Card: Select Amazon gift card as Primary to receive gift
          cards of equal value.
        </li>
      </ul>
      <div className="mb-3 text-[14px] sm:mb-8">
        All payouts are handled manually by the SnapThePrice operations team,
        ensuring secure and accurate transfers.
      </div>
      <div className="mb-1 text-[20px] font-bold sm:mb-3">
        Minimum Payout Threshold
      </div>
      <ul className="list-disc pl-5 text-[14px] text-[#4E5969]">
        <li className="mb-2">The minimum cash-out amount is $20 USD.</li>
        <li className="mb-3 text-[14px] sm:mb-8">
          Once your Payable Balance ≥ $20, you’re eligible to withdraw.
        </li>
      </ul>
      <div className="mb-1 text-[20px] font-bold sm:mb-3">
        Step-by-Step Guide to Cash Out Rewards
      </div>
      <div className="mb-1 font-bold sm:mb-3">
        Step 1: Log in to SnapThePrice
      </div>
      <div className="mb-2 text-[14px]">
        1. Go to{" "}
        <span onClick={handleClick} className="cursor-pointer underline">
          SnapThePrice.com
        </span>{" "}
      </div>
      <div className="mb-1 text-[14px] sm:mb-3">
        2. Click Login and sign in to your account.
      </div>
      <div className="mb-1 font-bold sm:mb-3">
        Step 2: Go to the Rewards Page
      </div>
      <div className="mb-2 text-[14px]">
        1. After logging in, navigate to the Rewards section.
      </div>
      <div className="mb-1 text-[14px] sm:mb-3">
        2. Here you’ll see your current Payable Balance and available cash-out
        options.
      </div>
      <div className="mb-1 font-bold sm:mb-3">
        Step 3: Configure Cashout Settings
      </div>
      <div className="mb-2 text-[14px]">1. Find and click Cashout Setting.</div>
      <div className="mb-1 text-[14px] sm:mb-3">
        2. Choose your preferred payout method:
      </div>
      <ul className="list-disc pl-5 text-[14px] text-[#4E5969]">
        <li className="mb-2">
          PayPal: Bind your PayPal account and set it as Primary.
        </li>
        <li className="mb-1 text-[14px] sm:mb-3">
          Amazon Gift Card: Select Amazon gift card and set it as Primary.
        </li>
      </ul>
      <div className="mb-1 font-bold sm:mb-3">Step 4: Check Your Balance</div>
      <ul className="list-disc pl-5 text-[14px] text-[#4E5969]">
        <li className="mb-2">Ensure your Payable Balance ≥ $20.</li>
        <li className="mb-1 text-[14px] sm:mb-3">
          If your balance doesn’t meet the threshold, continue snapping and
          earning until it does.
        </li>
      </ul>
      <div className="mb-1 font-bold sm:mb-3">Step 5: Receive Your Payout</div>
      <ul className="list-disc pl-5 text-[14px] text-[#4E5969]">
        <li className="mb-2">
          Once eligible, the SnapThePrice operations team will process your
          payout.
        </li>
        <li className="mb-3 text-[14px] sm:mb-8">
          Depending on your settings, you’ll receive either: A PayPal cash
          transfer, An Amazon gift card code.
        </li>
      </ul>
      <div className="mb-1 text-[20px] font-bold sm:mb-3">Summary</div>
      <div className="mb-1 text-[14px] sm:mb-3">
        Cashing out your SnapThePrice rewards is simple:
      </div>
      <div className="mb-2 text-[14px]">1. Log in at snaptheprice.com.</div>
      <div className="mb-2 text-[14px]">2. Go to the Rewards page.</div>
      <div className="mb-2 text-[14px]">
        3. Set up your Cashout Settings (PayPal or Amazon gift card).
      </div>
      <div className="mb-2 text-[14px]">
        4. Ensure your balance is $20 or more.
      </div>
      <div className="mb-2 text-[14px] sm:mb-6">
        5. Wait for the SnapThePrice team to process your payout.
      </div>
      <div className="mb-2 text-[14px] sm:mb-6">
        That’s it—you’ll soon receive your rewards as cash or gift cards! 🎉
      </div>
    </div>
  )
}
